import { Component } from '@angular/core';
import {BaseModalComponent, ClassificatorValuesQuery, GLOBAL} from "common-shared";
import {MasterOperationModel, MasterUseInstructionModel} from "web-shared";
import {IntegratedMasterService} from '../services/integrated-master.service'
import {ResourceService} from '../../resources/resource.service';
import {map} from "rxjs/operators";

@Component({
  selector: 'app-master-use-instruction-edit-modal',
  templateUrl: './master-use-instruction-edit-modal.component.html',
})
export class MasterUseInstructionEditModalComponent extends BaseModalComponent {
  masterInstruction: MasterUseInstructionModel;
  masterOperation: MasterOperationModel;
  readonly = false;
  resourceTemplates$ = this.resourceService.getAll$.pipe(map(resources => resources.filter(resource => resource.KindClv == GLOBAL.Classificators.ResourceKind.Template)));

  constructor(public integratedMasterService: IntegratedMasterService, public classificatorValuesQuery: ClassificatorValuesQuery, public resourceService: ResourceService) {
    super();
  }

  submit() {
    this.close(this.masterInstruction, 'change');
  }

  delete() {
    this.integratedMasterService.removeMasterUseInstruction(this.masterOperation, this.masterInstruction);
    this.close(this.masterInstruction, 'delete');
  }
}
